import { c as _c } from "react/compiler-runtime";
import { useControlledSwr } from '@systemeio/util';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import { getStudentProgressExportStatusPath } from '../api/student-api';
import { StudentProgressExportStatusEnum } from '../enums/student-progress-export-status-enum';
import { StudentProgressExportStatusResponse } from '../types/student-progress-export-interface';
export const useStudentProgressExportStatusPolling = t0 => {
  const $ = _c(7);
  const {
    exportId,
    allowFetch
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    fetcher
  } = useFetch(t1);
  let t2;
  if ($[1] !== exportId) {
    t2 = () => getStudentProgressExportStatusPath(exportId);
    $[1] = exportId;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      refreshInterval(latestData) {
        if (!latestData || latestData.status === StudentProgressExportStatusEnum.Running) {
          return 1500;
        }
        return 0;
      },
      errorRetryCount: 3
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const {
    data: exportStatus,
    mutate
  } = useControlledSwr(t2, fetcher, t3, allowFetch);
  let t4;
  if ($[4] !== exportStatus || $[5] !== mutate) {
    t4 = {
      exportStatus,
      mutate
    };
    $[4] = exportStatus;
    $[5] = mutate;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};